var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareIndeterminate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#107eab",
    viewBox: "0 0 576 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2138",
    transform: "translate(-1.6425 .74009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2363",
    transform: "matrix(1.1889 0 0 1.1889 -.037336 -96.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect2132",
    x: 0.1976,
    y: 81.189,
    width: 429.62,
    height: 430.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1959",
    x: 20.907,
    y: 101.29,
    width: 390.02,
    height: 390.02,
    fill: "none",
    stroke: "#107eab",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect2054",
    x: 24.735,
    y: 256.3,
    width: 382.37,
    height: 80,
    fill: "#107eab"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIndeterminate);
export default __webpack_public_path__ + "static/media/Square-indeterminate.8fdad52112799529bfe803a2115fe55f.svg";
export { ForwardRef as ReactComponent };